import { View } from 'react-native';
import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { mergeStyles } from 'src/_shared/utils/mergeStyles';
import { stylesMobile } from './ToolbarTile.styles';
import { BaseButton } from '@photosi/rn-components/buttons/base-button/BaseButton';
import { TBaseButtonProps } from '@photosi/rn-components/buttons/base-button/BaseButton.types';
import { Icon } from '@photosi/rn-components/icon/Icon';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/contexts/StoreContext';
import { brand, icon } from 'src/theme/colors';

export type ToolbarButtonMobileProps = {
  iconName: ICON_NAMES;
  isSelected?: boolean;
  text: string;
} & Omit<TBaseButtonProps, 'children'>;

export const ToolbarButtonMobile = observer(
  ({
    iconName,
    isSelected,
    text,
    style,
    testID,
    focusId,
    disabled,
    accessible = true,
    accessibilityLabel,
    accessibilityRole,
    ...buttonProps
  }: ToolbarButtonMobileProps) => {
    const { i18n } = useStore();
    const styles = stylesMobile;

    return (
      <BaseButton
        testID={testID}
        focusId={focusId ?? testID}
        style={mergeStyles([styles.buttonLookup, style, isSelected && styles.buttonSelected])}
        innerStyle={styles.buttonInner}
        focusStyle={styles.buttonFocus}
        hoverStyle={styles.buttonHover}
        disabledStyle={styles.buttonDisabled}
        disabled={disabled}
        accessible={accessible}
        accessibilityLabel={accessibilityLabel ?? i18n.t(text)}
        accessibilityRole={accessibilityRole ?? 'button'}
        {...buttonProps}
      >
        {() => (
          <>
            <View style={styles.icon}>
              <Icon name={iconName} color={disabled ? icon.iconColorDisabled : brand.main.water} />
            </View>
            <View style={styles.toolDetails}>
              <TextLato style={styles.toolDetailsText}>{i18n.t(text)}</TextLato>
            </View>
          </>
        )}
      </BaseButton>
    );
  },
);

ToolbarButtonMobile.displayName = 'ToolbarButtonMobile';
